import React from "react";
import { Link } from "react-router-dom";

const CheckoutSteps = ({ shipping, confirmOrder, payment }) => {
    return (
        <div className="checkout-progress">
            <Link to={shipping ? "/shipping" : "#!"} className={`step ${shipping ? "active-step" : "incomplete"}`}>
                Shipping
            </Link>
            <Link to={confirmOrder ? "/confirm_order" : "#!"} className={`step ${confirmOrder ? "active-step" : "incomplete"}`}>
                Confirm Order
            </Link>
            <Link to={payment ? "/payment_method" : "#!"} className={`step ${payment ? "active-step" : "incomplete"}`}>
                Payment
            </Link>
        </div>
    );
};

export default CheckoutSteps;
